<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { useProductStore } from '~/store/product/productStore';
import { money } from '~/helpers/product/productHelper';
import { MODAL_PROMO_PRICE } from '~/store/modalStore';

const productStore = useProductStore();
const {
  offer
} = storeToRefs(productStore);

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)
</script>

<template>
  <Modal
:id="MODAL_PROMO_PRICE"
         :is-visible="isModalVisible"
         :title="$t('www.product.modal_price_history.title')"
         @close="closeModal">
    <div>
      <ol class="mb-2">
        <li class="mb-h"><span class="c-quadra-text" v-html="$t('www.product.modal_price_history.currentPrice.0', {'finalPrice': `<span class=\'size--title-3 weight--interbold c-h-6-text\'>${money(offer.price.finalPrice)}</span>`})"/></li>
        <li v-if="offer.price.lowestPrice" class="mb-h"><span class="c-quadra-text" v-html="$t('www.product.modal_price_history.lowest_price.0', {'lowestPrice': money(offer.price.lowestPrice), 'discountFromLowestPricePercent': offer.price.discountFromLowestPricePercent})"/></li>
        <li v-if="offer.price.originalPrice" class="mb-h"><span class="c-quadra-text" v-html="$t('www.product.modal_price_history.original_price.0', {'originalPrice': money(offer.price.originalPrice), 'discountPercent': offer.price.discountPercent})"/></li>
      </ol>
      <ol>
        <li class="mb-h" v-html="$t('www.product.modal_price_history.currentPrice.text')"/>
        <li v-if="offer.price.lowestPrice" class="mb-h" v-html="$t('www.product.modal_price_history.lowest_price.text')"/>
        <li v-if="offer.price.originalPrice" class="mb-h" v-html="$t('www.product.modal_price_history.original_price.text')"/>
      </ol>
      <div class="italic-text">
        {{ $t('www.product.modal_price_history.mention') }}
      </div>
    </div>
  </Modal>
</template>
